<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center mb-3">
                <div class="col-md mb-2 mb-md-0">
                    <h1 class="page-header-title">Klienci API - SMS</h1>
                </div>
                <div class="col-md-auto">
                    <router-link class="btn btn-primary" to="/group/add">create</router-link>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="table-responsive">
                <table class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Identyfiaktor klienta</th>
                            <th scope="col">Liczba sms w tym miesiącu</th>
                            <th scope="col">Liczba sms w poprzednim mieiącu</th>
                            <th class="text-end">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item,index in items" :key="index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.client_id}}</td>
                            <td>{{item.sms.sms_count_current_month}}</td>
                            <td>{{item.sms.sms_count_last_month}}</td>
                            <td class="text-end">
                                <router-link :to="'/client/'+item.client_id+'/sms'" class="btn btn-outline-primary btn-icon-sm"><span class="material-icons-outlined">question_answer</span></router-link>
                                <DeleteConfirm @ok="deleteGroup(item)"></DeleteConfirm>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from '../../api/helpdesk-axios.js';
import MagicoModal from '../MagicoModal.vue';
import DeleteConfirm from '../DeleteConfirm.vue';

export default {
    name: 'GroupIndex',
    components: {
        MagicoModal,
        DeleteConfirm
    },
    data: function() {
        return {
            items: [],
            modalQr: false,
            qrCodeUrl: '',
        }
    },
    methods: {
        load: function() {
            let vm = this;
            axios.get('api/v1/sms/client').then(function(response) {
                vm.items = response.data.clients;
            })
        },
        openQrcode: function(item) {
            let vm = this;
            axios.get('api/v1/group/' + item.group_id + '/qrcode', {
                    responseType: 'arraybuffer',
                })
                .then(response => {
                    vm.qrCodeUrl = 'data:image/png;base64,' + Buffer.from(response.data, 'binary').toString('base64');
                })
            this.modalQr = true;
        },
        deleteGroup(group) {
            let vm = this;
            axios.delete('api/v1/group/' + group.group_id).then(function(response) {
                vm.load();
            })
        },
    },
    mounted() {
        if (!['owner', 'manager'].includes(this.$store.getters['app/role'])) {
            this.$router.push('/');
        }
        this.load();
    }
}
</script>